<template>
    <v-form>
        <br />
        <v-card flat :elevation="2" :loading="Loading" :disabled="Loading">
            <v-card-title>
                Serie histórica disponible
            </v-card-title>
            <v-card-text>
                <v-container>
                    <div class="container mt-4">
                        <!-- Encabezado -->
                        <div class="row header font-weight-bold bg-light border">
                            <div class="col-md-1 col-4 p-1 border-right">Año</div>
                            <div class="col-md-3 col-4 p-2 border-right">Valor</div>
                            <div v-if="anios.length >=1 && anios[0].length >= 2" class="col-md-1 col-4 p-1 border-right">Año</div>
                            <div v-if="anios.length >=1 && anios[0].length >= 2" class="col-md-3 col-4 p-2 border-right">Valor</div>
                            <div v-if="anios.length >=1 && anios[0].length >= 3" class="col-md-1 col-4 p-1 border-right">Año</div>
                            <div v-if="anios.length >=1 && anios[0].length >= 3" class="col-md-3 col-4 p-2">Valor</div>
                        </div>

                        <!-- Cuerpo de la tabla generado dinámicamente -->
                        <div v-for="(serie, index) in anios" :key="index" class="row">
                            <template v-for="(item, index1) in serie" >
                                <div  class="col-md-1 col-4 pt-3">
                                    <label dense class="v-label primary--text Label-primary">{{ item.nombrePeriodo}}</label>
                                </div>
                                <div class="col-md-3 col-4 py-1" :class="{ 'border-right': index1 < 2 }">
                                    <CurrencyInput
                                        :value="item.valor"
                                        v-model="item.valor"
                                        :options="{ currency:'COP', currencyDisplay: 'hidden', precision:4}"
                                    ></CurrencyInput>
                                    
                                </div>
                            </template>
                            <!-- Rellenar espacios vacíos si no hay 3 pares completos -->
                            <template v-if="serie.length < 3">
                                <div v-for="i in (3 - serie.length) * 2" :key="`empty-${i}`" class="col-md-2 col-4 p-2" :class="{ 'border-right': i < (3 - serie.length) * 2 - 1 }">&nbsp;</div>
                            </template>
                        </div>
                    </div>
                </v-container>
            </v-card-text>
        </v-card>
    </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CurrencyInput from '../global/inputnumber.vue'
export default {
    name: "serie_historica",
    components: { CurrencyInput },
    load: false,
    data: function () {
        return {
            idtest: -1,
            anios: []
            
        };
    },
    created() {
        this.get_series({ params: { idindicador: this.indicadorserie} });
        
    },
    props: {
        anoInicio : { required: true, type: Number, },
        anoFin : { required: true, type: Number, },
        indicadorserie : { required: true, type: Number, },
        Loading : { required: true, type: Boolean },
    },

    methods: {
        ...mapActions([
            "get_series",
            "get_addnuevaserie",
            "get_deletenuevaserie"
        ]),
        composeData() {
            let copyAnios = [];
            Object.assign(copyAnios, this.anios.flat())
            if(this.gseries.length >0 && this.anoInicio > 0 && this.anoFin > 0) {
                this.anios = Array.from({ length: (this.anoFin - this.anoInicio) + 1 }, (_, i) => ({
                    idserie : this.gseries[i].idserie,
                    idperiodo : this.gseries && this.gseries[i].idperiodo,
                    idindicador : this.gseries && this.gseries[i].idindicador,
                    nombrePeriodo: this.gseries && this.gseries[i].nombreperiodo,
                    valor: (this.gseries.length > 0 ) ? this.gseries[i].valor : 0
                }));
            }
            else
            {
                this.anios = [];
            }
            this.anios = this.formatData();  
        },
        AddNuevaSerieUP(anoserieup) {
            this.get_addnuevaserie({ params: { idindicador: this.indicadorserie, anoserieup: anoserieup, up: true } });
        },
        AddNuevaSerieDown(anoserieup) {
            this.get_addnuevaserie({ params: { idindicador: this.indicadorserie, anoserieup: anoserieup, up: false } });
        },
        DeleteNuevaSerieUP(anoserieup) {
            this.get_deletenuevaserie({ params: { idindicador: this.indicadorserie, anoserieup: anoserieup, up: true } });
        }, 
        DeleteNuevaSerieDown(anoserieup) {
            this.get_deletenuevaserie({ params: { idindicador: this.indicadorserie, anoserieup: anoserieup, up: false } });
        },        
        formatData() {
            // Dividimos los datos en grupos de 3 para mostrar 3 pares por fila
            const result = [];
            for (let i = 0; i < this.anios.length; i += 3) {
                result.push(this.anios.slice(i, i + 3));
            }
            return result;
        }
    },
    watch: {
        anoInicio: function(newVal, oldVal) {
            if (newVal != oldVal)
            {
                console.log('newVal != oldVal', newVal, oldVal)
                if ( oldVal > newVal)
                {
                    console.log('Values Validate', this.anoInicio, this.gseries[0].nombreperiodo)
                    if ( parseInt(this.anoInicio) < parseInt(this.gseries[0].nombreperiodo)) {
                        console.log('this.anoInicio Add', this.anoInicio)
                        this.AddNuevaSerieDown(parseInt(this.anoInicio))
                    }
                } else {
                    if ( parseInt(this.anoInicio) != parseInt(this.gseries[0].nombreperiodo)) {
                        console.log('this.anoInicio Delete', this.anoInicio, this.gseries[0].nombreperiodo)
                        this.DeleteNuevaSerieDown(parseInt(this.anoInicio))
                    }
                        
                }            
            }
        },
        anoFin: function(newVal, oldVal) {
            if (newVal != oldVal)
            {
                console.log('newVal != oldVal', newVal, oldVal)
                if ( oldVal < newVal)
                {
                    console.log('Values Validate', this.anoFin, this.gseries[this.gseries.length -1].nombreperiodo)
                    if ( parseInt(this.anoFin) > parseInt(this.gseries[this.gseries.length -1].nombreperiodo)) {
                        console.log('this.anoInicio Add', this.anoFin)
                        this.AddNuevaSerieUP(parseInt(this.anoFin))
                    }
                } else {
                    if ( parseInt(this.anoFin) != parseInt(this.gseries[this.gseries.length -1].nombreperiodo)) {
                        console.log('this.anoInicio Delete', this.anoFin, this.gseries[this.gseries.length -1].nombreperiodo)
                        this.DeleteNuevaSerieUP(parseInt(this.anoFin))
                    }
                        
                }            
            }
        },
        gseries: function() {
           if (this.gseries.length > 0) {
                this.composeData();
           } 
                
        }
    },
    computed: {
        ...mapGetters([
            "gseries",
        ]),
        ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    }
};
</script>
<style>
md1 .md-select-icon {
    display: none;
}
</style>